import './topBanner.scss';

import React, { forwardRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import store from 'utils/store';

import { CloseButton } from '../base';

const TOP_BANNER_VISIBLE = {
  KEY: 'topBannerVisible',
  VISIBLE: true,
  HIDDEN: false,
};

const TopBanner = forwardRef((props, ref) => {
  const [isHidden, setIsHidden] = useState();
  useEffect(() => {
    setIsHidden(
      store.session.get(TOP_BANNER_VISIBLE.KEY, TOP_BANNER_VISIBLE.VISIBLE) ===
        TOP_BANNER_VISIBLE.HIDDEN,
    );
  }, []);

  useEffect(() => {
    props.onVisibleChange(isHidden);
  }, [props.visible, props.onVisibleChange, isHidden]);

  if (!props.visible || isHidden || !props.children) {
    return null;
  }

  const className = classNames({
    'top-banner': true,
    [props.className]: props.className,
  });

  const handleOnCloseClick = e => {
    e.preventDefault();

    store.session.set(TOP_BANNER_VISIBLE.KEY, TOP_BANNER_VISIBLE.HIDDEN, true);
    setIsHidden(true);
  };

  return (
    <div ref={ref} className={className}>
      {props.children}
      <CloseButton onClick={handleOnCloseClick}>
        <span aria-hidden="true">&times;</span>
      </CloseButton>
    </div>
  );
});

TopBanner.propTypes = {
  visible: PropTypes.bool,
  onVisibleChange: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default TopBanner;
